import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { LocalStorageJwtService, SiteValidatorService } from '~/shared-common';
import { UtilService } from '~/shared-core/utils';

export const authGuard = (): Observable<boolean | UrlTree> => {
  const storage = inject(LocalStorageJwtService);
  const router = inject(Router);
  const siteValidatorService = inject(SiteValidatorService);
  const util = inject(UtilService);
  if (util.isBrowser()) {
    let current_url = window.location.pathname;
    if (current_url === '/') current_url = '';
    const prev_url = storage.getItemSTR('prev_url') ?? '';
    if (
      (prev_url && prev_url == current_url) ||
      current_url == '' ||
      current_url == '/'
    ) {
      storage.setItemSTR('prev_url', current_url);
    } else {
      if (
        current_url != '' &&
        current_url != '/' &&
        current_url.indexOf('landingpage') === -1
      )
        storage.setItemSTR('prev_url', current_url);
    }
  }

  return storage.getItem().pipe(
    map((token) => {
      if (!token && util.isBrowser()) {
        const hostName = siteValidatorService.checkGTPSite();
        if (!hostName) {
          router.navigateByUrl('/auth/login');
        }
        // B2B site: AppComponent owns the b2bLogin call; allow navigation
        // so public/protected routes can render once the session is established.
        return !!token || !!hostName;
      }
      return !!token;
    }),
    take(1),
  );
};
